<mat-progress-bar mode="indeterminate" *ngIf="loader" class="genie-progress-bar"></mat-progress-bar>
<div class="genie-page">
  <!-- Page Header Section -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <h1 class="genie-page-title">{{ 'Translations' | translate }}</h1>
      <p class="genie-page-subtitle">{{ 'Manage and translate your text strings across your entire system in all languages.' | translate }}</p>
    </div>
    <div class="header-right">
      <input type="text" class="genie-search-input" [(ngModel)]="searchText" (keyup)="filterData(true)" [placeholder]="'Search text' | translate" />
      <label class="genie-btn secondary">
        {{ 'Import Translations' | translate }}
        <input type="file" (change)="importTranslationData($event)" accept=".csv" hidden />
      </label>
      <button class="genie-btn primary" *ngIf="tableData.length > 0" (click)="exportTranslationData()">{{ 'Export CSV' | translate }}</button>
      <button class="genie-btn primary" (click)="loadData()">{{ 'Fetch New Strings' | translate }}</button>
    </div>
  </div>

  <!-- Main Content Card -->
  <div class="genie-content-card">
    <!-- Data Table -->
    <div class="genie-table-wrapper">
      <table class="genie-table">
        <thead>
          <tr>
            <th *ngFor="let lang of languages">
              {{ lang.title }}
              <span *ngIf="lang.title === defaultLanguage" class="default-lang-badge">({{ 'Default' | translate }})</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedTableData.data">
            <td *ngFor="let lang of languages">
              <div *ngIf="editingCell.row !== row || editingCell.lang !== lang.title">
                <div class="cell-content">
                  <p>{{ row[lang.title] }}</p>
                  <span class="material-icons material-icons-outlined edit-icon" (click)="toggleEdit(row, lang.title)">edit</span>
                </div>
              </div>
              <div *ngIf="editingCell.row === row && editingCell.lang === lang.title">
                <textarea class="edit-textarea" [(ngModel)]="row[lang.title]" [placeholder]="'Enter translation' | translate" (blur)="toggleEdit(row, lang.title)"></textarea>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Custom Pagination -->
    <div class="genie-pagination">
      <div class="pagination-info">
        <span class="current-page">{{ currentPageIndex + 1 }}</span>
        <span class="page-separator">of</span>
        <span class="total-pages">{{ getTotalPages() }}</span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn prev" [disabled]="currentPageIndex === 0" (click)="goToPreviousPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button class="page-btn next" [disabled]="currentPageIndex >= getTotalPages() - 1" (click)="goToNextPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
<form [formGroup]="txtTranslations" id="txtTranslations" (ngSubmit)="saveChanges()"></form>
